import { createContext, useContext, useEffect, useMemo } from "react";
import { toMilliseconds } from "../libs/utils";
import { MatchFilter } from "../libs/statsFilters";

export interface SettingsProviderProps {
  children: React.ReactNode;
}

export type SyncMetadata = {
  id: string;
  matches: {
    lastSyncedAt: number;
    lastItemId?: string;
  };
  match_events: {
    lastSyncedAt: number;
    lastItemId?: string;
  };
};

type SettingsContextType = {
  globals: {
    filters: MatchFilter;
  };
};

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

export const SettingsProvider: React.FC<SettingsProviderProps> = ({
  children,
}) => {
  useEffect(() => {}, []);

  const value: SettingsContextType = useMemo(
    () => ({
      globals: {
        filters: {
          orderType: ["s"],
          duration: {
            max: toMilliseconds({ hours: 5 }),
          },
          emails: { exclude: ["*@garipalli.com"] },
        },
      },
    }),
    []
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook to use IndexedDb
export const useSettings = (): SettingsContextType => {
  const context = useContext(SettingsContext);

  if (context == null) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }

  return context;
};
